import { useContext } from 'react';
import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { getOrCreateGlobalContext } from '@adsk/alloy-react-context';
export const useUnsafeCurrentProductId = () => {
  const currentProductIdContext = useContext(getOrCreateGlobalContext(CONTEXT_NAMES.CurrentProductIdContext));
  return currentProductIdContext === null || currentProductIdContext === void 0 ? void 0 : currentProductIdContext.productId;
};
export const useUnsafeCurrentToolId = () => {
  const currentToolIdContext = useContext(getOrCreateGlobalContext(CONTEXT_NAMES.CurrentToolIdContext));
  return currentToolIdContext === null || currentToolIdContext === void 0 ? void 0 : currentToolIdContext.toolId;
};
//# sourceMappingURL=ProvidersContexts.js.map